import React from 'react';

import { Col, Container, Row } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

import Menubar from '../Features/Common/Menubar';
import Sidebar from '../Features/Common/Sidebar';

const CommonLayout = () => {
  return (
    <div
      style={{
        width: '100dvw',
        height: '100dvh',
        overflowY: 'auto'
      }}
    >
      {/* <Container fluid> */}
      {/* <Row>
        <div className='sidenav-lg-parent'>
          <Col className='ps-0 d-none d-lg-block'>
            <Sidebar />
          </Col>
          <Col>
            <div className='outletDiv'>
              <Menubar />
              <div className='ps-3'>
                <Outlet />
              </div>
            </div>
          </Col>
        </div>
      </Row> */}

      <Row 
        className="g-0 h-100"
      >
        
        {/* Sidebar */}
        <Col
          className='d-none d-lg-block h-100'
          style={{ 
            width: '320px', 
            flex: '0 0 320px' 
          }}
        >
          <Sidebar />
        </Col>

        {/* Main Content Area */}
        <Col 
          className="d-flex flex-column h-100"
          style={{
            overflowY: 'auto'
          }}
        >
          <Menubar />
          
          <div 
            className='flex-1'
          >
            <Outlet />
          </div>

        </Col>

      </Row>
      {/* </Container> */}
    </div>
  )
}

export default CommonLayout;